import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextField from "@material-ui/core/TextField";
import { useNotify, useRefresh } from "react-admin";
import React, { useState } from "react";
import { apiUrl, getUser, httpClient } from "../../dataProvider";
import { Booking } from "../../types";

interface Props {
  data: Booking;
}

export const isReportSubmitted = (booking?: Booking): boolean => {
  if (!booking) {
    return false;
  }
  return Boolean(
    booking.reported_by || (booking.reports && booking.reports.length > 0),
  );
};

const UpdateReportRemarksDialog: React.FC<Props> = ({ data }) => {
  const [open, setOpen] = useState(false);
  const [saving, setSaving] = useState(false);
  const [remarks, setRemarks] = useState<string>(data.report_remarks ?? "");
  const notify = useNotify();
  const refresh = useRefresh();

  const handleClickOpen = () => {
    setRemarks(data.report_remarks ?? "");
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = async () => {
    if (!data.id) {
      return;
    }
    setSaving(true);
    try {
      await httpClient(`${apiUrl}/bookings/${data.id}/report-remarks`, {
        method: "PUT",
        body: JSON.stringify({ report_remarks: remarks }),
        ...getUser(),
      });
      notify("Report remarks updated.", "info");
      setOpen(false);
      refresh();
    } catch (error: any) {
      notify(`Error: ${error?.message || "Unknown error"}`, "warning");
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <Button
        style={{ marginLeft: 10 }}
        color="primary"
        onClick={handleClickOpen}
        size={"small"}
        variant="contained"
        disabled={saving}
      >
        Update Report Remarks
      </Button>
      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>Update Report Remarks</DialogTitle>
        <DialogContent>
          <TextField
            id="report-remarks"
            label="Report Remarks"
            placeholder="Add report remarks..."
            value={remarks}
            onChange={(event) => setRemarks(event.target.value)}
            multiline
            fullWidth
            rows={4}
            variant="outlined"
            disabled={saving}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary" disabled={saving}>
            Cancel
          </Button>
          <Button
            onClick={handleSave}
            color="primary"
            autoFocus
            disabled={saving}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default UpdateReportRemarksDialog;
